import {GridCellOrEmptyGridCell} from 'constants/SampleConstants';
import {SchemaTag} from 'folder-items/FileConstants';
import {ScrollableTableRow} from 'ui-library/scrollable/ScrollableTableConstants';

import {ContainerMeasurementsByContainerId} from './hooks/useContainerMeasurements';

export interface GridCellTableTableRow extends ScrollableTableRow {
  extra: {
    cell: GridCellOrEmptyGridCell;
    containedTags?: Array<SchemaTag>;
    containerQuantity?: ContainerMeasurementsByContainerId[string]['quantity'];
  };
}

export const GridSortOptionsPreferences = {
  COORDINATES_ORDER_BY_KEY: 'coordinates_order_by_key',
  COORDINATES_SORT_DIRECTION: 'coordinates_sort_direction',
};

export enum SortKey {
  COORDINATES = 'coordinates',
  VOLUME = 'volume',
}

export enum CoordinatesOrderingKey {
  ROW = 'row',
  COLUMN = 'column',
}
